import {
  Directive,
  OnInit,
  TemplateRef,
  ViewContainerRef,
  ChangeDetectorRef,
  inject,
  input,
  DestroyRef,
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

import { Store } from '@ngrx/store';
import { AppSelectors } from 'projects/semeris/src/store/app/app.selectors';
import { RootState } from 'projects/semeris/src/store/root-state.model';
import { distinctUntilChanged } from 'rxjs/operators';

@Directive({
  standalone: true,
  selector: '[ifAsset]',
})
export class IfAssetDirective implements OnInit {
  private readonly templateRef = inject<TemplateRef<any>>(TemplateRef);
  private readonly viewContainer = inject(ViewContainerRef);
  private readonly changeDetectorRef = inject(ChangeDetectorRef);
  private readonly store = inject<Store<RootState>>(Store);
  private readonly destroyRef = inject(DestroyRef);

  public readonly ifAsset = input<string>(undefined);
  readonly ifAssetElse = input<TemplateRef<any>>(undefined);

  public ngOnInit() {
    this.store
      .select(AppSelectors.selectedAssetShortNames)
      .pipe(distinctUntilChanged(), takeUntilDestroyed(this.destroyRef))
      .subscribe((assetShortNames) => {
        this.viewContainer.clear();

        const ifAssetElse = this.ifAssetElse();
        if (assetShortNames.includes(this.ifAsset())) {
          this.viewContainer.createEmbeddedView(this.templateRef);
        } else if (ifAssetElse) {
          this.viewContainer.createEmbeddedView(ifAssetElse);
        }

        this.changeDetectorRef.markForCheck();
      });
  }
}
